var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4912_446935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 5.9993C0.5 3.2226 2.55718 0.927223 5.23075 0.552734L5.63769 1.41673C4.9378 2.05733 4.5 2.97683 4.5 3.9993C4.5 5.9323 6.067 7.4993 8 7.4993C9.02247 7.4993 9.94197 7.0615 10.5826 6.36161L11.4466 6.76855C11.0721 9.44212 8.7767 11.4993 6 11.4993C2.96243 11.4993 0.5 9.03687 0.5 5.9993ZM3.97878 1.97754C2.50864 2.71792 1.5 4.24107 1.5 5.9993C1.5 8.48458 3.51472 10.4993 6 10.4993C7.75823 10.4993 9.28139 9.49067 10.0218 8.02052C9.4139 8.32671 8.727 8.4993 8 8.4993C5.51472 8.4993 3.5 6.48458 3.5 3.9993C3.5 3.27231 3.67259 2.5854 3.97878 1.97754Z",
    fill: "#9DA6B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4912_446935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.5eef0426bc2356bcb6665041203da2e0.svg";
export { ForwardRef as ReactComponent };